export default "__VITE_ASSET__DhSmVknt__"